export const MAX_OPTIONS_LENGTH = 5;
